import React from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import {
  Button, TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle, IconButton,
  colors, Typography, Grid
} from '@material-ui/core';
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import {Close} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  btnAceptar: {
    color: colors.green[500],
  },
  btnCancelar: {
    color: colors.red[500],
  }
}));
const FormConfirmacion = (props) => {
  const { open, titulo, ContenidoMensaje, OnCerrar, width, skroll, acciones, children, paddingDisabled } = props;
  const classes = useStyles();
  const classesTablero = useStylesTablero();
  return (
    <Dialog
      open={open}
      // onClose={OnCerrar} 
      fullWidth maxWidth={width}
      scroll={skroll}
      aria-labelledby="form-dialog-title">
      <DialogTitle className={classesTablero.dialogTitle}>
        <Grid container item xs={12}>
          <Grid item xs={9} style={{ alignSelf: 'center' }}>
            {titulo && <Typography variant="h4" className={classesTablero.dialogTitle}>{titulo}</Typography>}
          </Grid>
          <Grid item xs={3} style={{ textAlign: 'end' }}>
            {OnCerrar && <IconButton aria-label="close" onClick={OnCerrar} style={{ color: (theme) => theme.palette.grey[500], }}><Close /></IconButton>}
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent style={paddingDisabled ? { paddingLeft: 0, paddingRight: 0 } : {}}>
        <DialogContentText style={{ color: "white" }}>
          {ContenidoMensaje}
        </DialogContentText>
        <div className='MuiDialogContentText-root' >
          {children}
        </div>
      </DialogContent>
      <DialogActions>
        {acciones}
      </DialogActions>
    </Dialog>
  );
}
FormConfirmacion.propTypes = {
  open: PropTypes.bool.isRequired,
  titulo: PropTypes.string.isRequired
  , ContenidoMensaje: PropTypes.string
  , form: PropTypes.node,
  acciones: PropTypes.element.isRequired,
  paddingDisabled: PropTypes.bool,

}
FormConfirmacion.defaultProps = {
  width: "sm",
  skroll: 'paper',
  paddingDisabled: false
};
export default FormConfirmacion;